function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "check");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Healthcare_Renewal_System_Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "SA\\u2013[error]\\u2013Upload-presentations",
  transform: "translate(-952.000000, -337.000000)",
  fill: "#215EFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(736.000000, 276.000000)"
}, React.createElement("g", {
  id: "Group-5-Copy-7",
  transform: "translate(0.000000, 50.000000)"
}, React.createElement("g", {
  id: "check",
  transform: "translate(216.000000, 11.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0.694087404 7.22419929 5.69151671 12.6049822 17.3521851 0 18 0.697508897 5.69151671 14 0 7.92170819"
}))))));

var SvgTickWithNoBg = function SvgTickWithNoBg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickWithNoBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick-with-no-bg.69f212e7.svg";
export { ForwardRef as ReactComponent };